import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreate,
  useNotify,
  SimpleForm,
  TextInput,
  useResourceContext,
  required,
  choices,
  useRefresh,
  Create,
  RadioButtonGroupInput,
} from "react-admin";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import CorrectionProductForm from "../components/CorrectionProductForm";

const validateType = [
  required(),
  choices(["adj"], "Please choose one of the values"),
];
const validateCategory = [required()];
const validateNote = [required()];

export default function CorrectionAddDialog({ open, setOpen }) {
  const [create] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();
  const resource = useResourceContext(); // cuman nama resource
  const save = useCallback(
    async (values) => {
      try {
        await create(
          resource,
          { data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.created", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.body.errors) {
          // The shape of the returned validation errors must match the shape of the form
          return error.body.errors;
        }
      }
    },
    [create]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} keepMounted={false}>
      <Create title={" "} sx={{ "& .RaCreate-main": { mt: 0 } }}>
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>Koreksi Stok</DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <CorrectionProductForm />

            <TextInput
              disabled
              source="type"
              defaultValue="adj"
              sx={{ display: "none" }}
              validate={validateType}
            />

            <RadioButtonGroupInput
              source="category"
              choices={[
                { id: "-", name: "Kurangi" },
                { id: "+", name: "Tambah" },
              ]}
              validate={validateCategory}
              row={false}
            />
            {/* <SelectInput
              variant="outlined"
              source="type"
              choices={[
                { id: "in", name: "Masuk" },
                { id: "out", name: "Keluar" },
                { id: "adj", name: "Penyesuaian" },
              ]}
              fullWidth
              isRequired
              validate={validateType}
            /> */}

            <TextInput
              variant="outlined"
              source="note"
              fullWidth
              multiline
              minRows={3}
              maxRows={3}
              validate={validateNote}
            />
          </DialogContent>
        </SimpleForm>
      </Create>
    </Dialog>
  );
}
